import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

import { actionType, getModuleType } from "../../../shared/domain/learning/utils/util";

import Video from "./Video";
import PDFViewer from "./PDFViewer";
import Audio from "./Audio";
import Document from "./Document";
import Image from "./Image";
import Activity from "./Activity";
import Tracker from "./Tracker";

function Viewer(props) {
  return (
    {
      view: <Document link={props.fileUrl} />,
      audio: <Audio link={props.fileUrl} />,
      video: <Video link={props.fileUrl} />,
      watch: <Video link={props.fileUrl} />,
      show: <Image link={props.fileUrl} />,
      pdfview: <PDFViewer link={props.fileUrl} />,
      activity:<Activity link={props.fileUrl} />
    }[props.viewer] || <></>
  );
}

function Message({ children }) {
  return (
    <div style={{ margin: "150px auto" }}>
      <p style={{ margin: "auto", textAlign: "center" }}>{children}</p>
    </div>
  );
}

export default function Media(props) {
  const params = useParams();
  const [url, setURL] = useState({ link: "", viewer: "", loading: "", moduleName:"" });

  function fetchModule() {
    //fetch module
    axios
      .get(`${process.env.REACT_APP_ORIGIN}/api/v1/modules/${params.module}`, {
        headers: {
          token: window.localStorage.getItem("authToken"),
        },
        validateStatus: () => true,
      })
      .then((res) => {
        if (res.data.status !== "success") throw res.data;
        const moduleType = getModuleType(res.data.data?.module?.resources);
        setURL({
          loading: "loaded",
          link: moduleType.resource?.fileUrl,
          viewer: actionType(moduleType.fileType),
          moduleName:res.data?.data?.module?.name || ""
        });
      })
      .catch((err) => {
        console.log(err.message);
        setURL({ ...url, loading: "loaded" });
      });
  }

  useEffect(() => {
    if (url.loading === "loading") return;
    setURL({ ...url, loading: "loading" });
    if (props.location.useProps?.fileUrl) {
      setURL({
        link: props.location.useProps?.fileUrl,
        viewer: props.location.useProps?.viewer,
        moduleName:props.location.useProps?.moduleName,
      });
    } else {
      fetchModule();
    }
  }, [props.location]);

  const moduleName = useMemo(() => url.moduleName,[url]);

  useEffect(() => {
    console.log("LINE 83", url);
  },[url]);

  return (
    <Tracker moduleName={moduleName}>
      {url.link ? <Viewer viewer={url.viewer} fileUrl={url.link} /> : null}
      {!url.loading && url.loading === "loading" ? (
        <Message>Loading module...</Message>
      ) : null}
      {!url.link && url.loading === "loading" ? (
        <Message>Module not found</Message>
      ) : null}
    </Tracker>
  );
}
